import styled from "styled-components/macro";
import {device} from "../../styles";

export const Root = styled.div`
    display: grid;
    gap: 5px 30px;
    grid-template-columns: repeat(2, 1fr);

    ${device.less1180} {
        grid-template-columns: repeat(1, 1fr);
    }

    ${device.less768} {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }
`;

export const Item = styled.div``;
